import { isSubscriber } from '@alltrails/context/utils/isSubscriber';
import type Experiments from '@alltrails/types/Experiments';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';
import type { User } from '@alltrails/types/User';

type IsTripPlannerAvailableArgs = {
  experiments: Experiments;
  languageRegionCode?: LanguageRegionCode;
  user?: User | null;
};

/**
 * isTripPlannerAvailable checks that the trip planner is enabled and that the user can access it.
 * The trip planner has no dedicated feature entitlement, so access is granted to any paid tier.
 * The trip planner is not translated, so it is limited to en-US.
 */
export const isTripPlannerAvailable = ({ experiments, languageRegionCode, user }: IsTripPlannerAvailableArgs) =>
  languageRegionCode === 'en-US' && experiments['web-disco-rm-trip-planner']?.value === 'on' && isSubscriber(user);
